import React from "react";
import { CRMInboxTable } from "../CRMInboxTable/CRMInboxTable";
import { 
    TTriageForm, 
    TTriageSimpleEmailForm,
    TDetailedEmailForm, 
    TTriageAssigneeActiveTypeVisible,
    TTriageEmailDisassociateFromCaseForm,
    TTriageEmailMarkAsResolvedForm,
} from "../../../../../domain/codecs/form/TriageForm";
import { useTriage } from "../../../hooks/useTriage";
import { CRMCaseEmailSingleViewUnresolved } from "../CRMCaseEmailSingleViewUnresolved/CRMCaseEmailSingleViewUnresolved";
import { CRMBlockScrollCacheView, CRMBlockScrollResetView } from "../../CRM/CRMBlock/CRMBlockViews/CRMBlockViews";

type TCaseInboxProps = {
    unresolvedForm: TTriageForm;

    onDisassociate: (form: TTriageEmailDisassociateFromCaseForm) => void;
    onResolve: (form: TTriageEmailMarkAsResolvedForm) => void;
    onChangeChaseModeForm: (form: TTriageEmailMarkAsResolvedForm) => void;
    onOpenEmail: (email: TTriageSimpleEmailForm, triageType: TTriageAssigneeActiveTypeVisible) => void;
    onReply: (form: TDetailedEmailForm) => void;
    onForward: (form: TDetailedEmailForm) => void;
    onFileAttachments: (form: TDetailedEmailForm) => void;
    onLoadMore: (triageType: TTriageAssigneeActiveTypeVisible) => void;
    onSearchTermChange: (value: string) => void;
};

export const CRMCaseInbox = (props: React.PropsWithChildren<TCaseInboxProps>): JSX.Element => {
    const {
        isPresentEmailSetToOpen,
        onOpenEmail,
        onLoadMore,
        getTriageFormToUse,
        getOpenedEmail,
        isShowingNext,
        isShowingPrevious,
        closeSingleView,
        onDisassociate,
        onResolve,
        onNext,
        onPrevious,
    } = useTriage<"UNRESOLVED">({
        ...props,
        triageTypeVisible: "UNRESOLVED",
        getTriageFormToUseCallback: () => props.unresolvedForm,

        onDisassociate: props.onDisassociate,
        onArchive: () => undefined,
        onAssignToPerson: () => undefined,
        onBulkArchive: () => undefined,
        onResolve: props.onResolve,
        onAssignToCaseAndMe: () => undefined,
        onAssignToCaseAndStaff: () => undefined,
        onAssignToCaseAndHandler: () => undefined,
        onAssignToCaseAndResolve: () => undefined,
        onChangeSearchCaseQuery: () => undefined,
    });

    return (
        <>
            {/* EMAIL CARDS */}
            <CRMBlockScrollCacheView isShowing={!isPresentEmailSetToOpen()}>
                <CRMInboxTable
                    form={props.unresolvedForm}
                    mode="card"
                    onOpenEmail={onOpenEmail}
                    onLoadMore={onLoadMore}
                    onSearchTermChange={props.onSearchTermChange}
                    searchBarBottomOffset="46px"
                    showUnresolvedIndicator={true}
                />
            </CRMBlockScrollCacheView>

            {/* SINGLE EMAIL VIEW */}
            <CRMBlockScrollResetView isShowing={isPresentEmailSetToOpen()}>
                <CRMCaseEmailSingleViewUnresolved
                    count={getTriageFormToUse().children.counts.available_count}
                    email={getOpenedEmail()}
                    isShowingNext={isShowingNext()}
                    isShowingPrevious={isShowingPrevious()}
                    
                    onDisassociate={onDisassociate}
                    onResolve={onResolve}
                    onChangeChaseModeForm={props.onChangeChaseModeForm}
                    onClose={closeSingleView}
                    onNext={onNext}
                    onPrevious={onPrevious}

                    onReply={props.onReply}
                    onForward={props.onForward}
                    onFileAttachments={props.onFileAttachments}
                />
            </CRMBlockScrollResetView>
        </>
    );
};
